import React,{useRef} from "react";
/*
* hook used to track which request from several was last
* hook for paginated table
* */
export default function useRequestController() {
    const requestId = useRef();
    return {
        new:()=>{
            const current = Date.now();
            requestId.current = current;
            return current;
        },
        isLast:(id)=>{
            return requestId.current===id;
        }
    }
}